const config = {};

config.configBase = "/partneranalytics/pcredirect";

config.apiBasePath = {
  baseIp: window.REACT_APP_API_BASE_URL + "api/",
};
config.headers = {
  "Content-Type": "application/json",
};

const region = {
  name: "Region",
  variant: "outlined",
  className: "formControl",
  type: "form",
};
const state = {
  name: "State",
  variant: "outlined",
  className: "formControl",
  type: "form",
};
const zd_zdmt = {
  name: "ZD/ZDMT/ARD/MARD",
  variant: "outlined",
  className: "ZD",
  type: "form",
};
const rds_chain = {
  name: "RDS/Chain",
  variant: "outlined",
  className: "formControl",
  type: "form",
};
const retail = {
  name: "Retail Category",
  variant: "outlined",
  className: "formControl",
  type: "form",
};
const button = {
  name: "button",
  variant: "filled",
  className: "setButton",
  type: "button",
};
const jc = {
  name: "JC",
  variant: "outlined",
  className: "formControl",
  type: "form",
};
const rds_ard = {
  name: "RDS/ARD/MARD",
  variant: "outlined",
  className: "ZD",
  type: "form",
};
const scheme_type = {
  name: "Scheme Type",
  variant: "outlined",
  className: "formControl",
  type: "form",
};
const scheme = {
  name: "Scheme Name",
  variant: "outlined",
  className: "formControl",
  type: "form",
};
const all_jc_jp = {
  name: "All/JC/JP",
  variant: "outlined",
  className: "formControl",
  type: "form",
};
const all_jp = {
  name: "All/JP",
  variant: "outlined",
  className: "formControl",
  type: "form",
};
const distributors = {
  name: "Distributors",
  variant: "outlined",
  className: "formControl",
  type: "form",
};
const retailers = {
  name: "Retailers",
  variant: "outlined",
  className: "formControl",
  type: "form",
};
const partner_name = {
  name: "Partner Name",
  variant: "outlined",
  className: "ZD",
  type: "form",
};

config.dashboardFilterFormConf = {
  NHQ: [region, state, zd_zdmt, rds_chain, retail, button],
  REGION: [state, zd_zdmt, rds_chain, retail, button],
  STATE: [zd_zdmt, rds_chain, retail, button],
  AREA: [jc, rds_ard, retail, button],
  JC: [rds_ard, all_jc_jp, retail, button],
  JP: [all_jp, retail, button],
  PARTNER: [retail, button],
  RZD: [retail, button],
};

config.payoutFilterFormConf = {
  NHQ: [region, state, zd_zdmt, rds_chain, scheme_type, scheme, button],
  REGION: [state, zd_zdmt, rds_chain, scheme_type, scheme, button],
  STATE: [zd_zdmt, rds_chain, scheme_type, scheme, button],
  AREA: [jc, rds_ard, scheme_type, scheme, button],
  JC: [rds_ard, all_jc_jp, scheme_type, scheme, button],
  ZD: [ distributors,scheme_type, scheme, retailers, button],
  RDS: [scheme_type, scheme, retailers, button],
  END: [scheme_type, scheme, button],
};

config.SmbAndFiberFilterFormConf = {
  NHQ: [region, state, partner_name, button],
  REGION: [state, partner_name, button],
  STATE: [partner_name, button],
};

config.SmbAndFiberFilterFormConfForPayout = {
  NHQ: [region, state, partner_name, scheme_type, scheme, button],
  REGION: [state, partner_name, scheme_type, scheme, button],
  STATE: [partner_name, scheme_type, scheme, button],
  END: [scheme_type, scheme, button],
  JBA: [scheme_type, scheme, button],
  JBAP: [scheme_type, scheme, button],
  J4: [scheme_type, scheme, button],
  DLCO: [scheme_type, scheme, button],
  EV: [scheme_type, scheme, button],
  Z8: [scheme_type, scheme, button],
  ET: [scheme_type, scheme, button],
  HSP: [scheme_type, scheme, button],
  ARD: [scheme_type, scheme, button],
  MARD: [scheme_type, scheme, button],
  XG: [scheme_type, scheme, button],
  DE: [scheme_type, scheme, button],
  DO: [scheme_type, scheme, button],
  DQ: [scheme_type, scheme, button],
  DX: [scheme_type, scheme, button],
  EO: [scheme_type, scheme, button],
  EU: [scheme_type, scheme, button],
  J1: [scheme_type, scheme, button],
  J2: [scheme_type, scheme, button],
  J3: [scheme_type, scheme, button],
  JA: [scheme_type, scheme, button],
  JB: [scheme_type, scheme, button],
  J7: [scheme_type, scheme, button],
  JH: [scheme_type, scheme, button],
  JK: [scheme_type, scheme, button],
  JX: [scheme_type, scheme, button],
  JY: [scheme_type, scheme, button],
  JZ: [scheme_type, scheme, button],
  QD: [scheme_type, scheme, button],
  QE: [scheme_type, scheme, button],
  Z7: [scheme_type, scheme, button],
  FTX: [scheme_type, scheme, button],
};

let date = new Date();
date.setDate(date.getDate() - 6);
config.startDate = date; //new Date("03-Sep-2020");
config.endDate = new Date();

config.region = ["East", "North", "South", "West"];

config.regionMaps = {
  EAST: "East",
  NORTH: "North",
  SOUTH: "South",
  WEST: "West",
};

config.states = {
  North: [
    "Delhi",
    "Haryana",
    "Himachal pradesh",
    "Jammu",
    "Kashmir",
    "Punjab",
    "Rajasthan",
    "Uttar pradesh (east)",
    "Uttar pradesh (west)",
    "Uttarakhand",
  ],
  East: [
    "Assam",
    "Bihar",
    "Jharkhand",
    "Kolkata",
    "North east",
    "Orissa",
    "West bengal",
  ],
  South: ["Andhra pradesh", "Karnataka", "Kerala", "Tamil nadu", "Telangana"],
  West: [
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Madhya pradesh",
    "Maharashtra",
    "Mumbai",
  ],
};

config.retailCatagory = [
  "All",
  "A",
  "A+",
  "ALL JPR",
  "B",
  "C",
  "D",
  "JC JPR",
  "JPR JP",
  "National JPR",
  "Non JPR",
  "Non JPR JP",
  "State JPR",
];

config.validateRoleTypes = {
  RDS: {
    showFilters: true,
    businessType: false,
    // showCategory: true,
  },
  ZD: {
    showFilters: true,
    businessType: false,
  },
  ZDMT: {
    showFilters: false,
    businessType: false,
  },
  CHAIN: {
    showFilters: false,
    businessType: false,
  },
  DT: {
    showFilters: false,
    businessType: false,
  },
  ITZ: {
    showFilters: false,
    businessType: false,
  },
  ARD: {
    showFilters: true,
    businessType: false,
  },
  ITD: {
    showFilters: false,
    businessType: false,
  },
  MARD: {
    showFilters: true,
    businessType: false,
  },
  RZD: {
    showFilters: true,
    businessType: false,
  },
  END: {
    showFilters: false,
    businessType: false,
  },
  XG: {
    showFilters: false,
    businessType: false,
  },
  //business
  NHQ: {
    showFilters: true,
    businessType: true,
  },
  AREA: {
    showFilters: true,
    businessType: true,
  },
  REGION: {
    showFilters: true,
    businessType: true,
  },
  STATE: {
    showFilters: true,
    businessType: true,
  },
  GENERAL_RETAILERS: {
    showFilters: true,
    businessType: true,
  },
  JC: {
    showFilters: true,
    businessType: true,
  },
  JP: {
    showFilters: true,
    businessType: true,
  },
  JBA: {
    showFilters: false,
    businessType: false,
  },
  JBAP: {
    showFilters: false,
    businessType: false,
  },
  J4: {
    showFilters: false,
    businessType: false,
  },
  DLCO: {
    showFilters: false,
    businessType: false,
  },
  EV: {
    showFilters: false,
    businessType: false,
  },
  Z8: {
    showFilters: false,
    businessType: false,
  },
  ET: {
    showFilters: false,
    businessType: false,
  },
  HSP: {
    showFilters: false,
    businessType: false,
  },
  J7: {
    showFilters: false,
    businessType: false,
  },
  JX: {
    showFilters: false,
    businessType: false,
  },
  JY: {
    showFilters: false,
    businessType: false,
  },
  DE: {
    showFilters: false,
    businessType: false,
  },
  DO: {
    showFilters: false,
    businessType: false,
  },
  DQ: {
    showFilters: false,
    businessType: false,
  },
  DX: {
    showFilters: false,
    businessType: false,
  },
  EO: {
    showFilters: false,
    businessType: false,
  },
  EU: {
    showFilters: false,
    businessType: false,
  },
  J1: {
    showFilters: false,
    businessType: false,
  },
  J2: {
    showFilters: false,
    businessType: false,
  },
  J3: {
    showFilters: false,
    businessType: false,
  },
  JA: {
    showFilters: false,
    businessType: false,
  },
  JB: {
    showFilters: false,
    businessType: false,
  },
  JH: {
    showFilters: false,
    businessType: false,
  },
  JK: {
    showFilters: false,
    businessType: false,
  },
  JZ: {
    showFilters: false,
    businessType: false,
  },
  QD: {
    showFilters: false,
    businessType: false,
  },
  QE: {
    showFilters: false,
    businessType: false,
  },
  Z7: {
    showFilters: false,
    businessType: false,
  },
  FTX: {
    showFilters: false,
    businessType: false,
  },
};

config.JPforJC = ["JC TOWN", "JP TOWN", "JP - ABC - IR94"];

export default config;
